import "../../App.css";

function Loader() {
  return (
    <div className="container loader-section">
      <div className="loader"></div>;
    </div>
  );
}

export default Loader;